import { checkPermission } from '@/router/guards.ts'

const VoucherReportsModule = () => import('./VoucherReportsModule.vue')
const VouchersReportIndex = () => import('./views/VouchersReportIndex.vue')
const VouchersRedemptionReportIndex = () => import('./views/VouchersRedemptionReportIndex.vue')
const VouchersRedemptionCouponReportIndex = () =>
  import('./views/VouchersRedemptionCouponReportIndex.vue')
const VouchersDistributionReportIndex = () => import('./views/VouchersDistributionReportIndex.vue')

export const voucherReportsRoute = {
  path: '/report',
  component: VoucherReportsModule,
  meta: {
    title: 'Vouchers Report',
    requiresAuth: true,
    keepAlive: true,
  },
  children: [
    {
      path: 'vouchers',
      name: 'vouchers-report-index',
      component: VouchersReportIndex,
      meta: {
        permission: 'report.vouchers',
      },
      beforeEnter: checkPermission('report.vouchers'),
    },
    {
      path: 'vouchers/redemption',
      name: 'vouchers-redemption-report-index',
      component: VouchersRedemptionReportIndex,
      meta: {
        permission: 'report.vouchers_redemption',
      },
      beforeEnter: checkPermission('report.vouchers_redemption'),
    },
    {
      path: 'vouchers/redemption-coupon',
      name: 'vouchers-redemption-coupon-report-index',
      component: VouchersRedemptionCouponReportIndex,
      meta: {
        permission: 'report.vouchers_redemption',
      },
      beforeEnter: checkPermission('report.vouchers_redemption'),
    },
    {
      path: 'vouchers/distribution',
      name: 'vouchers-distribution-report-index',
      component: VouchersDistributionReportIndex,
      meta: {
        permission: 'report.vouchers_distribution',
      },
      beforeEnter: checkPermission('report.vouchers_distribution'),
    },
  ],
}
